import {
  UNIFIED_DASHBOARD_PATH,
  HOLDINGS_HUB_PATH,
  MARKET_PULSE_HUB_PATH,
} from "components/allInOneDashboard/constants/productRouteMap";

export const BOTTOM_NAV_HEIGHT = 72;

export const BOTTOM_NAV_ITEMS = [
  {
    id: "home",
    label: "Home",
    path: UNIFIED_DASHBOARD_PATH,
    icon: "home",
  },
  {
    id: "holdings",
    label: "Holdings",
    path: HOLDINGS_HUB_PATH,
    icon: "holdings",
  },
  {
    id: "blogs",
    label: "Blogs",
    path: "/customer/blogs",
    icon: "blogs",
  },
  {
    id: "marketPulse",
    label: "Market Pulse",
    path: MARKET_PULSE_HUB_PATH,
    icon: "marketPulse",
    highlighted: true,
  },
];
